<template>
	<section role="contentinfo">
			<FooterQuickLinks />
			<FooterComplianceBadges />
			<FooterInfo />
	</section>
</template>

<style scoped>
section{
	flex-direction: column;
	gap: 30px;
}
@media (min-width: 1024px) {
div{
    width: 90%;
}
}
</style>
